"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateFormatter = void 0;
/**
* This is for DateTimes that have been localized already on the backend
* Where we only use the Date part, but the return includes a timezone offset of 0
* Use bdLocalDate for LocalDates
*
*
* @depends buildium.common.Locale
*
*/

var DateFormatter = exports.DateFormatter = function exports(Locale) {
  return function dateFormatter(input) {
    return Locale.formatDate(input, Locale.getDateFormat());
  };
};
DateFormatter.$inject = ['Locale'];